import api from "services/api";

export const SubmitCertificateFormData = async (certificateFile: File) => {
  const formDataCertificate = new FormData();

  formDataCertificate.append('document', certificateFile);
  formDataCertificate.append('document_type_id', '2');

  try {
    await api.post('/documents', formDataCertificate);

    return Promise.resolve();
  } catch (error: any) {
    return Promise.reject(error?.response?.data?.message);
  }
}
